module.exports = __webpack_public_path__ + "img/A58A0209.9f246b30.jpg";